import { PureComponent } from 'react';
import { connectAsAny } from 'utils/redux/connectAsAny';
import { fetchVpnStatus, vpnStart, vpnStop } from './actions';

import { Button } from 'components/Button/Button';
import LTEBox from 'containers/LTEBox';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { createStructuredSelector } from 'reselect';
import fetch from 'utils/fetch';
import handleEvent from 'utils/handleEvent';
import StatusIcon from './StatusIcon';
import { CONNECTED_ENUM } from './constants';
import { makeSelectSupportVpn } from './selectors';

@fetch({ actions: [fetchVpnStatus] })
class VpnSupport extends PureComponent {
  static propTypes = {
    msg: PropTypes.object.isRequired,
    vpn: PropTypes.object.isRequired,
    onVpnStart: PropTypes.func.isRequired,
    onVpnStop: PropTypes.func.isRequired,
  };

  getStatusIcon = (status) => <StatusIcon status={status} />;

  handleConnectBtnClick = handleEvent((e) => {
    e.preventDefault();
    this.props.onVpnStart();
  });

  handleDisconnectBtnClick = handleEvent((e) => {
    e.preventDefault();
    this.props.onVpnStop();
  });

  render() {
    const {
      vpn: { connectionState, statusText, disableButton },
      msg: {
        support: { vpn: msg },
      },
    } = this.props;
    return (
      <div className='m-4'>
        <Helmet title={msg.title} />
        <LTEBox
          bodyComponent={
            <div>
              <ul className='list-inline'>
                {[CONNECTED_ENUM.disconnected].includes(connectionState) && (
                  <li className='inline-block align-middle'>
                    <Button
                      variant='primary'
                      data-container='body'
                      onClick={this.handleConnectBtnClick}
                      title={msg.connectButton}
                      loading={disableButton}
                      icon='fa-plug'
                    >
                      {msg.connectButton}
                    </Button>
                  </li>
                )}
                {[CONNECTED_ENUM.connected].includes(connectionState) && (
                  <li className='inline-block align-middle'>
                    <Button
                      variant='primary'
                      accent='negative'
                      data-container='body'
                      onClick={this.handleDisconnectBtnClick}
                      title={msg.disconnectButton}
                      loading={disableButton}
                      icon='fa-power-off'
                    >
                      {msg.disconnectButton}
                    </Button>
                  </li>
                )}
                <li className='inline-block align-middle'>
                  <table>
                    <tbody>
                      <tr>
                        <td style={{ paddingRight: 5 }}>
                          {this.getStatusIcon(connectionState)}
                        </td>
                        <td>
                          {msg.vpnStatus}
                          {msg[connectionState]}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
              </ul>
              <hr />
              {msg.logs}
              <textarea
                disabled
                rows={20}
                style={{ width: '100%', height: '100%' }}
                value={statusText}
              />
            </div>
          }
          className='box box-primary'
          title={msg.title}
        />
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  vpn: makeSelectSupportVpn(),
});

function mapDispatchToProps(dispatch) {
  return {
    onVpnStart: (args) => dispatch(vpnStart(args)),
    onVpnStop: (args) => dispatch(vpnStop(args)),
  };
}

export default connectAsAny(mapStateToProps, mapDispatchToProps)(VpnSupport);
